export default {
  category: {
    title: 'Quản lý danh mục bài viết',
    addNew: 'Thêm danh mục',
    createTitle: 'Tạo danh mục',
    editTitle: 'Chỉnh sửa danh mục',
    form: {
      category: 'Danh mục',
      categoryPlaceholder: 'Nhập tên danh mục',
      categoryRequired: 'Vui lòng nhập tên danh mục',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      isActive: 'Hoạt động',
      isActivePlaceholder: 'Chọn trạng thái',
      name: 'Tên danh mục',
      namePlaceholder: 'Nhập tên danh mục',
      nameRequired: 'Vui lòng nhập tên danh mục',
      slug: 'Định danh',
      slugPlaceholder: 'Vui lòng nhập định danh',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả danh mục',
      sortOrder: 'Thứ tự sắp xếp',
      sortOrderPlaceholder: 'Số nhỏ hơn sẽ hiện trước',
      seoTitle: 'Tiêu đề SEO',
      seoTitlePlaceholder: 'Nhập tiêu đề SEO',
      seoDescription: 'Mô tả SEO',
      seoDescriptionPlaceholder: 'Nhập mô tả SEO',
      seoKeywords: 'Từ khóa SEO',
      seoKeywordsPlaceholder: 'Ngăn cách nhiều từ khóa bằng dấu phẩy',
      canonicalUrl: 'URL chuẩn',
      canonicalUrlPlaceholder: 'Nhập URL chuẩn',
      ogTitle: 'Tiêu đề OG',
      ogTitlePlaceholder: 'Nhập tiêu đề OG',
      ogDescription: 'Mô tả OG',
      ogDescriptionPlaceholder: 'Nhập mô tả OG',
      ogImage: 'Hình ảnh OG',
      ogImagePlaceholder: 'Nhập URL hình ảnh OG',
    },
    table: {
      name: 'Tên danh mục',
      slug: 'Định danh',
      description: 'Mô tả',
      language: 'Ngôn ngữ',
      isActive: 'Trạng thái',
      sortOrder: 'Thứ tự',
      updateTime: 'Cập nhật lúc',
      action: 'Hành động',
    },
    tabs: {
      basic: 'Thông tin cơ bản',
      seo: 'Cài đặt SEO',
      og: 'Cài đặt OG',
    },
  },
  tag: {
    title: 'Quản lý thẻ bài viết',
    addNew: 'Thêm thẻ',
    createTitle: 'Tạo thẻ',
    editTitle: 'Chỉnh sửa thẻ',
    form: {
      tag: 'Thẻ',
      tagPlaceholder: 'Nhập tên thẻ',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      isActive: 'Hoạt động',
      isActivePlaceholder: 'Chọn trạng thái',
      name: 'Tên thẻ',
      namePlaceholder: 'Nhập tên thẻ',
      nameRequired: 'Vui lòng nhập tên thẻ',
      slug: 'Định danh',
      slugPlaceholder: 'Vui lòng nhập định danh',
      description: 'Mô tả',
      descriptionPlaceholder: 'Nhập mô tả thẻ',
      seoTitle: 'Tiêu đề SEO',
      seoTitlePlaceholder: 'Nhập tiêu đề SEO',
      seoDescription: 'Mô tả SEO',
      seoDescriptionPlaceholder: 'Nhập mô tả SEO',
      seoKeywords: 'Từ khóa SEO',
      seoKeywordsPlaceholder: 'Ngăn cách nhiều từ khóa bằng dấu phẩy',
      canonicalUrl: 'URL chuẩn',
      canonicalUrlPlaceholder: 'Nhập URL chuẩn',
      ogTitle: 'Tiêu đề OG',
      ogTitlePlaceholder: 'Nhập tiêu đề OG',
      ogDescription: 'Mô tả OG',
      ogDescriptionPlaceholder: 'Nhập mô tả OG',
      ogImage: 'Hình ảnh OG',
      ogImagePlaceholder: 'Nhập URL hình ảnh OG',
    },
    table: {
      name: 'Tên thẻ',
      slug: 'Định danh',
      description: 'Mô tả',
      isActive: 'Trạng thái',
      usageCount: 'Số lần sử dụng',
      updateTime: 'Cập nhật lúc',
      action: 'Hành động',
    },
    tabs: {
      basic: 'Thông tin cơ bản',
      seo: 'Cài đặt SEO',
      og: 'Cài đặt OG',
    },
  },
  article: {
    title: 'Quản lý danh sách bài viết',
    addNew: 'Thêm bài viết',
    createTitle: 'Tạo bài viết',
    editTitle: 'Chỉnh sửa bài viết',
    form: {
      keyword: 'Tiêu đề bài viết',
      keywordPlaceholder: 'Nhập tiêu đề bài viết',
      category: 'Danh mục',
      categoryPlaceholder: 'Chọn danh mục',
      categoryRequired: 'Vui lòng chọn danh mục',
      language: 'Ngôn ngữ',
      languagePlaceholder: 'Chọn ngôn ngữ',
      languageRequired: 'Vui lòng chọn ngôn ngữ',
      status: 'Trạng thái',
      statusPlaceholder: 'Chọn trạng thái',
      dateRange: 'Ngày xuất bản',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      title: 'Tiêu đề bài viết',
      titlePlaceholder: 'Nhập tiêu đề bài viết',
      titleRequired: 'Vui lòng nhập tiêu đề bài viết',
      slug: 'Định danh',
      slugPlaceholder: 'Vui lòng nhập định danh',
      summary: 'Tóm tắt',
      summaryPlaceholder: 'Nhập tóm tắt bài viết',
      content: 'Nội dung',
      coverImage: 'Ảnh bìa',
      coverImagePlaceholder: 'Nhập URL ảnh bìa',
      publishedAt: 'Ngày xuất bản',
      tags: 'Thẻ',
      tagsPlaceholder: 'Chọn thẻ',
      sortOrder: 'Thứ tự sắp xếp',
      sortOrderPlaceholder: 'Số nhỏ hơn sẽ hiện trước',
      isTop: 'Ghim lên đầu',
      seoEnabled: 'Bật SEO',
      seoTitle: 'Tiêu đề SEO',
      seoTitlePlaceholder: 'Nhập tiêu đề SEO',
      seoDescription: 'Mô tả SEO',
      seoDescriptionPlaceholder: 'Nhập mô tả SEO',
      seoKeywords: 'Từ khóa SEO',
      seoKeywordsPlaceholder: 'Ngăn cách nhiều từ khóa bằng dấu phẩy',
      canonicalUrl: 'URL chuẩn',
      canonicalUrlPlaceholder: 'vd: https://www.yoursite.com/article/Points/123',
      ogTitle: 'Tiêu đề OG',
      ogTitlePlaceholder: 'Nhập tiêu đề OG',
      ogDescription: 'Mô tả OG',
      ogDescriptionPlaceholder: 'Nhập mô tả OG',
      ogImage: 'Hình ảnh OG',
      ogImagePlaceholder: 'Nhập URL hình ảnh OG',
    },
    table: {
      id: 'ID',
      article: 'Bài viết',
      coreSeo: 'SEO cốt lõi',
      coverImage: 'Ảnh bìa',
      socialOg: 'OG mạng xã hội',
      isTop: 'Ghim',
      status: 'Trạng thái',
      viewCount: 'Lượt truy cập (PV/UV)',
      action: 'Hành động',
      title: 'Tiêu đề',
      category: 'Danh mục',
      tags: 'Thẻ',
      language: 'Ngôn ngữ',
      publisher: 'Người xuất bản',
      updateTime: 'Thời gian cập nhật',
      canonicalUrl: 'URL chuẩn',
      seoKeywords: 'Từ khóa',
      dynamicParams: 'Tham số động',
      noImage: 'Không có ảnh',
      noOgImage: 'Không có ảnh OG',
      publishedAt: 'Ngày xuất bản',
    },
    status: {
      pending: 'Chờ duyệt',
      published: 'Đã xuất bản',
      rejected: 'Đã từ chối',
    },
      actions: {
        preview: 'Xem trước',
        edit: 'Chỉnh sửa',
        seoEdit: 'Chỉnh sửa SEO',
        delete: 'Xóa',
        approve: 'Phê duyệt',
        reject: 'Từ chối',
        confirmApprove: 'Bạn có chắc muốn phê duyệt bài viết này?',
        confirmReject: 'Bạn có chắc muốn từ chối bài viết này?',
      },
      seoEdit: 'Chỉnh sửa SEO & OG',
    tabs: {
      basic: 'Thông tin cơ bản',
      seo: 'Cài đặt SEO',
      og: 'Cài đặt OG',
    },
  },
  internalLink: {
    title: 'Quản lý từ khóa liên kết nội bộ',
    add: 'Thêm từ khóa',
    edit: 'Chỉnh sửa từ khóa',
    keyword: 'Từ khóa',
    keywordTag: 'Thẻ từ khóa',
    keywordPlaceholder: 'Vui lòng nhập từ khóa',
    url: 'URL',
    urlPlaceholder: 'Vui lòng nhập URL',
    isBrand: 'Từ khóa thương hiệu',
    maxReplacement: 'Số lần thay thế tối đa',
    maxReplacementPlaceholder: 'Nhập số lần thay thế tối đa (Mặc định: 5 cho thường, 2 cho thương hiệu)',
    isActive: 'Kích hoạt',
  },
};

